import React from 'react'

const useFormList = () => {

  const renderTagContent = (item) => {
    if (!item?.codigo && item?.codigoProspect) return "Prospect";
    if ([1, 2].includes(item?.tipo)) return "Emissor/Recebedor";
    else if ([3, 4].includes(item?.tipo)) return "Recebedor";
    return "";
  };
  const montaEndereco = (endereco) => {
    return `${endereco.rua ? endereco.rua + " " : ""}${endereco.numero ? endereco.numero + " " : ""}${
      endereco.complemento ? endereco.complemento + " " : ""
    }${endereco.bairro ? "- " + endereco.bairro + " " : ""}${
      endereco.cidade?.nome ? "- " + endereco.cidade?.nome : ""
    }${endereco.cidade?.estado?.sigla ? "/" + endereco.cidade?.estado?.sigla + " " : ""}${
      endereco.cep ? "- " + endereco.cep : ""
    }`;
  };


  return {
    renderTagContent,
    montaEndereco
  }
}

export default useFormList